'use strict';

var _promisePolyfill = require('promise-polyfill');

var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!window.Promise) {
    window.Promise = _promisePolyfill2.default;
}


//////////////////
// WEBPACK FOOTER
// ./Resources/Private/Javascript/polyfill/promise.js
// module id = 134
// module chunks = 3